import { DateTime } from "luxon";
import { useState, useEffect } from "react";
import { BsFillQuestionCircleFill } from 'react-icons/bs';
import { ScheduleItem } from ".";
import { IApiGetClientProgramSchedule } from "../../../api/models/Program";
import { AppPageHeader } from "../../../components/AppPageHeader";
import { IconButton } from "../../../components/Buttons";
import { Modal } from "../../../components/Modal";

interface ScheduleContentProps {
    scheduleData: IApiGetClientProgramSchedule
}

export const ScheduleContent: React.FC<ScheduleContentProps> = ({
    scheduleData
}) => {
    const [selectedWeek, setSelectedWeek] = useState<string>();
    const [programInfoModal, setProgramInfoModal] = useState(false);

    const { clientPrograms, programs, programWeeks, programDays, programDayLogs } = scheduleData;

    const clientProgram = clientPrograms[0];

    const program = programs.find(program => program._id === clientProgram.program);

    const weeks = programWeeks.filter(week => week.programId === program?._id);

    const days = programDays.filter(day => weeks.map(week => week._id).includes(day.programWeekId));

    const start = DateTime.fromJSDate(new Date(clientProgram.startDate));
    const today = DateTime.fromJSDate(new Date());
    const weekDiff = Math.ceil(today.diff(start, "weeks").weeks) - 1;

    useEffect(() => {
        if(!selectedWeek) {
            setSelectedWeek(weeks[weekDiff]._id);
        }
    }, [weeks]);
    
    return (
        <>
        <AppPageHeader title="My Program" primaryAction={
            <div className="ml-auto flex items-center ">
                <div className="h-12 border rounded-md border-gray-200 pr-2">
                    <select value={selectedWeek} onChange={(e) => setSelectedWeek(e.currentTarget.value)} className="h-full px-4 rounded-md bg-transparent border-none">
                        {weeks.map(week => <option value={week._id}>Week {week.order + 1}</option>)}
                    </select>
                </div>
                <div className="ml-2">
                    <IconButton label="View program information" onClick={() => setProgramInfoModal(true)}>
                        <BsFillQuestionCircleFill />
                    </IconButton>
                </div>
            </div>
        } />
        <div className="flex w-full h-screen-padded">
                <div className="flex-1">
                    <div className="px-6 pb-4">
                        {weeks.filter(week => selectedWeek ? week._id === selectedWeek : week).map(week => {
                            return (
                                <>
                                    <h3 className="text-xl font-medium mb-4">Week {week.order + 1}</h3>
                                    {days.filter(day => day.programWeekId === week._id).map((day) => 
                                        <ScheduleItem day={day} week={week} clientProgram={clientProgram} programLog={programDayLogs.find(log => log.programDay === day._id)?._id} key={day._id} />
                                    )}
                                </>
                            );
                        })}
                    </div>
                </div>
            </div>
            <Modal isOpen={programInfoModal} closeModal={() => setProgramInfoModal(false)} title="Progam Information">
                <h3 className="text-lg font-medium">{program?.name}</h3>
                <p>{program?.description}</p>
                <p className="mt-4"><span className="font-medium">Start date: </span>{DateTime.fromISO(clientProgram.startDate).toFormat("dd MMM yyyy")}</p>
                <p className="mt-4"><span className="font-medium">Current week: </span>Week {weekDiff + 1}</p>
            </Modal>
        </>
    );
};